import React from 'react';
import './App.css';
//import { useForm } from 'react-hook-form';
import { Route, Routes } from 'react-router-dom';
//import Home from './pages/Home';
import Home from './homepage/App';
import About from './pages/About';
import NumberPage from './pages/NumberPage';
import Mes from './pages/Mes';
import Login from './pages/Login';
import InputData from './pages/InputData';
import VerifyData from './pages/VerifyData';
import Ended from './pages/Ended';
import NewInput from './inputpage/App';

//type FormData = {
  //email: string;
  //password: string;
//};
//
export const ApiUrl = "https://www.moopener.com/recruit/api/";

function App() {
//  const { register, handleSubmit } = useForm<FormData>();

//  const onSubmit = handleSubmit((data) => console.log(data));

  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Home/>} />
        <Route path="/about" element={<About/>} />
        <Route path="/number" element={<NumberPage/>} />
        <Route path="/mes" element={<Mes/>} />
        <Route path="/login" element={<Login/>} />
        <Route path="/inputdata" element={<InputData/>} />
        <Route path="/verifydata" element={<VerifyData/>} />
        <Route path="/ended" element={<Ended/>} />
        <Route path="/newinput" element={<NewInput/>} />
      </Routes>
    </div>
  );
}

export default App;
